module.exports = __webpack_public_path__ + "static/media/meaningful-review-product4-small.39335979.svg";